// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"915e54ec","517":"0e30feb0","763":"bcf25650","890":"96d77c2d","893":"a3c1e82d","896":"52a8f5f6","909":"8d873d71","932":"9bccda52"}[chunkId] + ".chunk.js";
};